import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    IconButton,
    Chip
} from "@material-tailwind/react";
import { PlusIcon } from "@heroicons/react/24/outline";
import TaskCard from './TaskCard';

const BoardColumn = ({ status, tasks, onAddTask }) => {
    const { setNodeRef } = useDroppable({
        id: status.name
    });

    const getStatusColor = (statusType) => {
        const colors = {
            'open': 'bg-gray-100 border-gray-300',
            'in_progress': 'bg-blue-50 border-blue-300',
            'completed': 'bg-green-50 border-green-300',
            'cancelled': 'bg-red-50 border-red-300'
        };
        return colors[statusType] || 'bg-gray-100 border-gray-300';
    };

    return (
        <div className="flex-shrink-0 w-80">
            <Card className={`h-full ${getStatusColor(status.type)} border-2`}>
                <CardHeader
                    floated={false}
                    shadow={false}
                    className="rounded-none bg-transparent p-4"
                >
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <div
                                className="w-3 h-3 rounded-full"
                                style={{ backgroundColor: status.color || '#808080' }}
                            />
                            <Typography variant="h6" color="blue-gray" className="font-semibold">
                                {status.name}
                            </Typography>
                            <Chip
                                value={tasks.length}
                                size="sm"
                                className="bg-white"
                            />
                        </div>
                        <IconButton
                            variant="text"
                            size="sm"
                            onClick={onAddTask}
                            className="hover:bg-white/50"
                        >
                            <PlusIcon className="h-4 w-4" />
                        </IconButton>
                    </div>
                </CardHeader>

                <CardBody
                    ref={setNodeRef}
                    className="p-2 space-y-2 overflow-y-auto max-h-[calc(100vh-250px)]"
                >
                    <SortableContext
                        items={tasks.map(t => t.id)}
                        strategy={verticalListSortingStrategy}
                    >
                        {tasks.length === 0 ? (
                            <div className="text-center py-8">
                                <Typography variant="small" color="gray">
                                    No tasks
                                </Typography>
                            </div>
                        ) : (
                            tasks.map((task) => (
                                <TaskCard key={task.id} task={task} />
                            ))
                        )}
                    </SortableContext>
                </CardBody>
            </Card>
        </div>
    );
};

export default BoardColumn;
